import { stringify } from 'qs';
import request from '../utils/request';

export async function queryProjectNotice() {
  return request('/api/project/notice');
}

export async function queryActivities() {
  return request('/api/activities');
}

export async function queryRule(params) {
  return request(`/api/rule?${stringify(params)}`);
}

export async function removeRule(params) {
  return request('/api/rule', {
    method: 'POST',
    body: {
      ...params,
      method: 'delete',
    },
  });
}

export async function addRule(params) {
  return request('/api/rule', {
    method: 'POST',
    body: {
      ...params,
      method: 'post',
    },
  });
}

export async function updateRule(params) {
  return request('/api/rule', {
    method: 'POST',
    body: {
      ...params,
      method: 'update',
    },
  });
}

export async function fakeSubmitForm(params) {
  return request('/api/forms', {
    method: 'POST',
    body: params,
  });
}

export async function fakeChartData() {
  return request('/api/fake_chart_data');
}

export async function queryTags() {
  return request('/api/tags');
}

export async function queryBasicProfile() {
  return request('/api/profile/basic');
}

export async function queryAdvancedProfile() {
  return request('/api/profile/advanced');
}

export async function queryFakeList(params) {
  return request(`/api/fake_list?${stringify(params)}`);
}

export async function removeFakeList(params) {
  const { count = 5, ...restParams } = params;
  return request(`/api/fake_list?count=${count}`, {
    method: 'POST',
    body: {
      ...restParams,
      method: 'delete',
    },
  });
}

export async function addFakeList(params) {
  const { count = 5, ...restParams } = params;
  return request(`/api/fake_list?count=${count}`, {
    method: 'POST',
    body: {
      ...restParams,
      method: 'post',
    },
  });
}

export async function updateFakeList(params) {
  const { count = 5, ...restParams } = params;
  return request(`/api/fake_list?count=${count}`, {
    method: 'POST',
    body: {
      ...restParams,
      method: 'update',
    },
  });
}

export async function fakeAccountLogin(params) {
  return request('/api/login/account', {
    method: 'POST',
    body: params,
  });
}

export async function fakeRegister(params) {
  return request('/api/register', {
    method: 'POST',
    body: params,
  });
}

export async function queryNotices() {
  return request('/api/notices');
}

export async function getFakeCaptcha(mobile) {
  return request(`/api/captcha?mobile=${mobile}`);
}

export async function checkCode(params, noti) {
  return request(`/voucher/vouchers-checkout`, {
    method: 'POST',
    body: params,
  }, noti);
}

export async function infoCode(params, noti) {
  return request(`/voucher/codes/verify`, {
    method: 'POST',
    body: params,
  }, noti);
}

// report

export async function reportActiveCard(params,noti = false){
  return request(`/partner/report-active-cardcode?${stringify(params)}`, null, noti);
}
export async function reportProductMoney(params, noti = false) {
  return request(`/product/report-product-money?${stringify(params)}`, null, noti);
}
export async function reportGotCode(params, noti = false) {
  return request(`/voucher/report-got-code?${stringify(params)}`, null, noti);
}
export async function reportUsedCode(params, noti = false) {
  return request(`/voucher/report-used-code?${stringify(params)}`, null, noti);
}
export async function reportPointExchange(params, noti = false) {
  return request(`/exchange/report-exchange-points?${stringify(params)}`, null, noti);
}
export async function reportPointExchangeByMember(params, noti = false) {
  return request(`/exchange/report-exchange-points-member?${stringify(params)}`, null, noti);
}

export async function reportTransactionCode(params, noti) {
  return request(`/exchange/report-transaction-code?${stringify(params)}`, null, noti);
}

export async function reportUserOfPartner(params, noti) {
  return request(`/exchange/report-users-partner?${stringify(params)}`, null, noti);
}

export async function reportTotalPoints(params, noti) {
  return request(`/exchange/report-total-points?${stringify(params)}`, null, noti);
}

export async function reportBillingCode(params, noti) {
  return request(`/exchange/report-billing-code?${stringify(params)}`, null, noti);
}
export async function reportExportProduct(params, noti) {
  return request(`/product/report-export-product?${stringify(params)}`, null, noti);
}
export async function importExportProduct(params, noti) {
  return request(`/product/report-import-product?${stringify(params)}`, null, noti);
}